module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAWCAYAAADTlvzyAAAAO0lEQVRIiWM07f//nwETMGIRowpgopXBuMCohaMWjlo4auGohaMWDkILWXCIY6uUqQJGE80Qt5CBgQEAyZgD8I2tIGkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/border_3.png
// module id = 7Bjq
// module chunks = 1